const conditions = () => {
  return [{ assetClass: { $ne: '' } }, { projectType: { $in: ['object.project-type.options.project-development'] } }]
}

export default conditions
